import React, { useState, useEffect, useRef } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import ERPSBaseTextField from "../custom/inputs/ERPSBaseTextField";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton";
import ERPSBaseDialog from "../custom/inputs/style/ERPSBaseModelDialogStyle";
import DialogHeader from "../custom/inputs/ERPSBaseModelDialog";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { marketManagementAction } from "../../actions/marketingManagement.action";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import ErrorMessage from "../custom/containers/ErrorMessage";
import parse from "html-react-parser";
import { validateURL } from "../../utils/helper";
import CommonContainerBox from "../custom/containers/CommonContainerBox";
import { Alert, Box, Card, CardContent, DialogActions, DialogContent, HStack, ResponsiveBox, Stack, Typography, VStack } from "../primitives";

const ManageMessageCentre = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const loginUser = useSelector((state) => state.loginUserReducer?.user);
  const selectedFi = useSelector((state) => state.fiReducer?.selectedFi);

  const fiNumber = selectedFi || loginUser.user?.fiNumber;

  const successRef = useRef(null);
  const warningRef = useRef(null);

  const successMessage = useSelector(
    (state) => state.marketingManagementReducer?.createDashboardMessage
  );
  const errorMessage = useSelector(
    (state) => state.marketingManagementReducer?.createDashboardError
  );
  const getDashboardErrorMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardError
  );
  const getDashboardMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardMessage
  );
  const [showExceptionMessage, setShowExceptionMessage] = useState(false);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setSuccessMessage] = useState(false);
  const [hasShowWarningMessage, setShowWarningMessage] = useState(false);
  const [originalMessages, setOriginalMessages] = useState([]);
  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, [successMessage && showSuccessMessage]);

    useEffect(() => {
  if (hasShowWarningMessage && warningRef.current) {
    warningRef.current.focus();
  }
}, [hasShowWarningMessage]);

  useEffect(() => {
    dispatch(
      marketManagementAction.getDashboardMessage({ setShowExceptionMessage })
    );
  }, []);

  const [messagesList, setMessagesList] = useState([
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.french_label"),
      },
      messageId: 1,
    },
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.french_label"),
      },
      messageId: 2,
    },
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.french_label"),
      },
      messageId: 3,
    },
  ]);

  const getFormattedData = (dashboardData) => {
    let dataV1 = [];
    dashboardData.forEach((data, idx) => {
      dataV1.push({
        en: {
          header: data?.messageHeaderEnglish,
          message: data?.messageTextEnglish,
          urlText: data?.messageLinkTextEnglish,
          urlLink: data?.messageUrlEnglish,
          type: t("erps.header.language.english_label"),
          id: `${idx + 1}`,
        },
        fr: {
          header: data?.messageHeaderFrench,
          message: data?.messageTextFrench,
          urlText: data?.messageLinkTextFrench,
          urlLink: data?.messageUrlFrench,
          type: t("erps.header.language.french_label"),
          id: `${idx + 1}`,
        },
        messageId: data?.id,
      });
    });
    return dataV1;
  };

  const descriptionElementRef = useRef(null);
  const errorRef = useRef();

  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.focus();
    }
  }, [getDashboardErrorMessage, errorMessage]);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if (getDashboardMessage && getDashboardMessage.length) {
      let dataV1 = getFormattedData(getDashboardMessage);
      setMessagesList(dataV1);
      setOriginalMessages(dataV1);
    }
  }, [getDashboardMessage]);

  const getUpdatedUrlValue = (value) => {
    const updatedValue = value.replace(/ +/g, "");
    const hasProtocol =
      /^(https\:\/\/|http\:\/\/|https\:\/|http\:\/|https\:|http\:|https|http)/.test(
        updatedValue
      );

    if (hasProtocol) {
      return updatedValue;
    }
    return `http://${updatedValue}`;
  };

  const handleChange = (type, key, indexVal) => (e) => {
    const slicedVal = messagesList.slice();
    const objVal = slicedVal[indexVal];
    const updatedObj = {
      ...objVal,
      [type]: {
        ...objVal[type],
        [key]: e.target.value,
      },
    };
    slicedVal.splice(indexVal, 1, updatedObj);
    setMessagesList(slicedVal);
  };
  const handleBlur = (type, key, indexVal) => (e) => {
    const trimmedValue = e?.target?.value?.trim();
    if (trimmedValue) {
      const slicedVal = messagesList.slice();
      const objVal = slicedVal[indexVal];
      const updatedUrlValue = getUpdatedUrlValue(trimmedValue);
      const updatedObj = {
        ...objVal,
        [type]: {
          ...objVal[type],
          [key]:
            updatedUrlValue?.length > 256
              ? updatedUrlValue?.slice(0, 256)
              : updatedUrlValue,
        },
      };
      slicedVal.splice(indexVal, 1, updatedObj);
      setMessagesList(slicedVal);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const formatReqBody = (reqData) => {
    const resData = [];
    reqData.forEach((reqBody) => {
      resData.push({
        id: reqBody["en"]?.id,
        messageTextEnglish: reqBody["en"]?.message,
        messageUrlEnglish: reqBody["en"]?.urlLink,
        messageLinkTextEnglish: reqBody["en"]?.urlText,
        messageTextFrench: reqBody["fr"]?.message,
        messageLinkTextFrench: reqBody["fr"]?.urlText,
        messageUrlFrench: reqBody["fr"]?.urlLink,
        messageHeaderEnglish: reqBody["en"]?.header,
        messageHeaderFrench: reqBody["fr"]?.header,
        fiNumber: fiNumber,
      });
    });
    return resData;
  };


  const isMessagesEqual = (currentMessages, originalMessages) => {
  return JSON.stringify(currentMessages) === JSON.stringify(originalMessages);
};

const handleSave = () => {
  const updatedReqBody = formatReqBody(messagesList);
  const currentFormatted = formatReqBody(originalMessages);

  if (isMessagesEqual(updatedReqBody, currentFormatted)) {
    setShowWarningMessage(true);
    setSuccessMessage(false); 
    setLoading(false);
    return;
  }

  setShowWarningMessage(false); 
  setLoading(true);
  setShowExceptionMessage(false);

  dispatch(
    marketManagementAction.createdDashboardMessage({
      data: updatedReqBody,
      setLoading: (val) => {
        setLoading(val);
        if (!val) {
          setOriginalMessages(messagesList);
          setShowWarningMessage(false); 
        }
      },
      setSuccessMessage,
      setShowExceptionMessage,
    })
  );
};

  const getCardComponent = (lan) => {
    const messagesContent = messagesList.map((data) => data[lan]);

    return (
      <>
        <ResponsiveBox mb={2}>
          <Typography variant="h3">
            {lan === "en"
              ? t("erps.header.language.english_label")
              : t("erps.header.language.french_label")}
          </Typography>
        </ResponsiveBox>

        <Card className="messageCenter__card__container">
          <CardContent>
            <Typography
              variant="h2"
              className="messageCenter__card__content__header"
            >
              {t("erps.login.message.card.title", "Messages")}
            </Typography>
            {messagesContent.map(
              ({ header, message, urlText, urlLink }, idx) => (
                <ResponsiveBox key={idx} mt={2}>
                  {header && (
                    <Typography
                      variant="h3"
                      className="messageCenter__card__content__heading"
                    >
                      {header}
                    </Typography>
                  )}
                  <Typography
                    variant="body1"
                    className="signIn__card__content__header"
                  >
                    {message ? parse(message) : ""}
                    {message && <br />}
                    {(urlText || urlLink) && (
                      <ERPSBaseLink
                        label={urlText || urlLink}
                        to={{
                          pathname: !validateURL(urlLink)
                            ? `http://${urlLink}`
                            : urlLink,
                        }}
                        target={"_blank"}
                        className="signIn__card__content__link"
                      />
                    )}
                  </Typography>
                </ResponsiveBox>
              )
            )}
          </CardContent>
        </Card>
      </>
    );
  };

  return (
    <div role="main">
      {successMessage && showSuccessMessage && (
        <ConfirmationMessage
          message={successMessage}
          setShowMessage={setSuccessMessage}
          inputRef={successRef}
        />
      )}
      <ErrorMessage 
        error={showExceptionMessage || getDashboardErrorMessage ? (errorMessage || getDashboardErrorMessage) : null}
        errorRef={errorRef}
        mt={2}
      />

      {hasShowWarningMessage && (
        <VStack sx={{ width: "100%" }} spacing={2} tabIndex={0} ref={warningRef}>
          <Alert severity="warning">
            {t("erps.billermanagement.warning.nothinghaschanged")}
          </Alert>
        </VStack>
      )}

      <Box ml={3}>
        <ResponsiveBox width={{ xs: "100%", lg: "66.666%" }} maxWidth="100%">
          <ResponsiveBox mt={4}>
            {/* For Title update */}
            <CommonContainerBox
              title={t("erps.marketingManagement.manageMessageCenter.heading")}
            />
            <Typography variant="h1">
              {t("erps.marketingManagement.manageMessageCenter.heading")}
            </Typography>
          </ResponsiveBox>
          <ResponsiveBox mt={3}>
            <Typography variant="body1">
              {t("erps.marketingManagement.manageMessageCenter.subheading")}
            </Typography>
          </ResponsiveBox>
          {messagesList &&
            messagesList.length &&
            messagesList.map(({ messageId, en, fr }, idx) => (
              <ResponsiveBox key={messageId || idx}>
                <ResponsiveBox mt={5}>
                  <Typography variant="h2">{`Message ${idx + 1}`}</Typography>
                </ResponsiveBox>
                <ResponsiveBox>
                  <ResponsiveBox mt={2}>
                    <Typography variant="h3">{en.type}</Typography>
                  </ResponsiveBox>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`en-header${en.id}`}
                      type="text"
                      value={en.header}
                      onChange={handleChange("en", "header", idx)}
                      label={t("erps.marketingManagement.textField.header")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                  </HStack>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`en-message${en.id}`}
                      type="text"
                      value={en.message}
                      onChange={handleChange("en", "message", idx)}
                      label={t("erps.marketingManagement.textField.message")}
                      className="textField_dimensions_manageMessageCentre_message"
                      size="small"
                      fullWidth
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                  </HStack>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`en-urlText${en.id}`}
                      type="text"
                      value={en.urlText}
                      onChange={handleChange("en", "urlText", idx)}
                      label={t("erps.marketingManagement.textField.urlText")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                    <ERPSBaseTextField
                      id={`en-urlLink${en.id}`}
                      type="text"
                      value={en.urlLink}
                      onChange={handleChange("en", "urlLink", idx)}
                      label={t("erps.marketingManagement.textField.url")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                      onBlur={handleBlur("en", "urlLink", idx)}
                    />
                  </HStack>
                </ResponsiveBox>
                <ResponsiveBox>
                  <ResponsiveBox mt={4}>
                    <Typography variant="h3">{fr.type}</Typography>
                  </ResponsiveBox>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`fr-header${fr.id}`}
                      type="text"
                      value={fr.header}
                      onChange={handleChange("fr", "header", idx)}
                      label={t("erps.marketingManagement.textField.header")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                  </HStack>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`fr-message${fr.id}`}
                      type="text"
                      value={fr.message}
                      onChange={handleChange("fr", "message", idx)}
                      label={t("erps.marketingManagement.textField.message")}
                      className="textField_dimensions_manageMessageCentre_message"
                      size="small"
                      fullWidth
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                  </HStack>
                  <HStack spacing={3}>
                    <ERPSBaseTextField
                      id={`fr-urlText${fr.id}`}
                      type="text"
                      value={fr.urlText}
                      onChange={handleChange("fr", "urlText", idx)}
                      label={t("erps.marketingManagement.textField.urlText")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                    />
                    <ERPSBaseTextField
                      id={`fr-urlLink${fr.id}`}
                      type="text"
                      value={fr.urlLink}
                      onChange={handleChange("fr", "urlLink", idx)}
                      label={t("erps.marketingManagement.textField.url")}
                      className="textField_dimensions_manageMessageCentre_header"
                      size="small"
                      onInput={(e) => {
                        e.target.value = e.target?.value.slice(0, 256);
                      }}
                      onBlur={handleBlur("fr", "urlLink", idx)}
                    />
                  </HStack>
                </ResponsiveBox>
              </ResponsiveBox>
            ))}

          <HStack spacing={2}>
          <ERPSBaseButton
            variant="secondary"
            className="button_with_margin48"
            label={t(
              "erps.marketingManagement.secondary.button.discardChanges"
            )}
            onClick={() => {
              if (getDashboardMessage && getDashboardMessage.length) {
                const dataV1 = getFormattedData(getDashboardMessage);
                setMessagesList(dataV1);
              } else {
                setMessagesList([
                  {
                    en: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 1,
                      type: t("erps.header.language.english_label"),
                    },
                    fr: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 1,
                      type: t("erps.header.language.french_label"),
                    },
                    messageId: 1,
                  },
                  {
                    en: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 2,
                      type: t("erps.header.language.english_label"),
                    },
                    fr: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 2,
                      type: t("erps.header.language.french_label"),
                    },
                    messageId: 2,
                  },
                  {
                    en: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 3,
                      type: t("erps.header.language.english_label"),
                    },
                    fr: {
                      header: "",
                      message: "",
                      urlText: "",
                      urlLink: "",
                      id: 3,
                      type: t("erps.header.language.french_label"),
                    },
                    messageId: 3,
                  },
                ]);
              }
            }}
          />
          <ERPSBaseButton
            variant="secondary"
            className="button_with_margin48"
            onClick={handleOpen}
            label={t(
              "erps.marketingManagement.secondary.button.previewMessages"
            )}
          />
          <ERPSBaseButton
            variant="primary"
            onClick={handleSave}
            className="button_with_margin48"
            label={t("erps.marketingManagement.primary.button.save")}
            loading={loading}
          />
        </HStack>
        <ERPSBaseDialog
          role="dialog"
          onClose={handleClose}
          aria-labelledby="delete-profile-dialog"
          open={open}
        >
          <DialogHeader
            id="delete-profile-dialog"
            onClose={handleClose}
            style={{
              fontFamily: "Roboto,Regular",
              fontSize: "18px",
              color: "#2a2c2e",
            }}
          >
            {t("erps.marketingManagement.manageMessageCenter.dialog.header")}
          </DialogHeader>
          <DialogContent>
            <ResponsiveBox>{getCardComponent("en")}</ResponsiveBox>
            <ResponsiveBox mt={3} mb={2}>
              {getCardComponent("fr")}
            </ResponsiveBox>
          </DialogContent>
          <DialogActions className={"leftAlignDialogActions"}>
            <ERPSBaseButton
              variant="secondary"
              className="button_with_zeromargin"
              onClick={handleClose}
              label={t("erps.marketingManagement.dialog.closeButton")}
            />
          </DialogActions>
        </ERPSBaseDialog>
        </ResponsiveBox>
      </Box>
    </div>
  );
};
export default withSidebar(ManageMessageCentre);
